import truncate from "html-truncate";
import {FormatDateTime} from "../../helpers/FormatDateTime";
import {useEffect, useState} from "react";
import {NoticeService} from "../../services/NoticeService";
import {NewLoading} from "../NewLoading";
import {useNavigate} from "react-router-dom";
import {BadgeAlert, LucideRabbit} from "lucide-react";
import Swal from "sweetalert2";
import {UpdateLauncherModal} from "../modals/UpdateLauncherModal";
import SimpleModal from "../modals/SimpleModal";
import {StandaloneService} from "../../services/StandaloneService";

export const UpdateLauncherPage = () => {
    const navigate = useNavigate();

    const {getNotices} = NoticeService();

    const [notices, setNotices] = useState([]);
    const [noticesLoading, setNoticesLoading] = useState(false);

    const [isUpdateModalOpened, setIsUpdateModalOpened] = useState(false);
    const [downloadTotalBytes, setDownloadTotalBytes] = useState(0);
    const [downloadBytes, setDownloadBytes] = useState(0);
    const [downloadProgress, setDownloadProgress] = useState(0);

    useEffect(() => {
        noticesLoader();
    }, []);

    const noticesLoader = async () => {
        setNoticesLoading(true);
        try {
            const response = await getNotices(1, 3);
            setNotices(response.data);
        } catch (err) {
            console.error("Erro ao buscar notices:", err);
        }
        setNoticesLoading(false);
    };

    const handleUpdateClickBtn = async () => {
        Swal.showLoading();

        try {
            const resp = await StandaloneService().verifyUpdate();
        } catch (e) {
            const newVersion = e.response.data.data.newVersionInfo;
            if (window.jsInterop) {
                window.jsInterop.handleUpdateCall(newVersion);
            }
            // Swal.fire({
            //     text: JSON.stringify(e.response.data.data.newVersionInfo)
            // });
        }
    };

    window.startUpdateDownload = function (totalBytes) {
        Swal.close();

        setDownloadTotalBytes(totalBytes);
        setIsUpdateModalOpened(true);
    };

    window.handleUpdateProgress = async function (downloadedBytes, progress) {
        setDownloadBytes(downloadedBytes);
        setDownloadProgress(progress);

        if(parseInt(progress) >= 100) {
            await delay(800);
        }
    };

    function delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    return (<div className="flex flex-col">
        <div className={"w-full p-8"}>
            <div className={"mb-8"}>
                <div className="flex items-center mb-4">
                    {/*<i className="fas fa-newspaper text-blue-500 mr-2"></i>*/}
                    <BadgeAlert size={24} className={"text-blue-500 mr-2"}></BadgeAlert>
                    <h3 className="text-xl font-semibold text-gray-800">Nova versão disponível</h3>
                </div>

                <div className={"flex sm:flex-col md:flex-row w-full"}>
                    <div className={"md:w-4/5"}>
                        <div className={"flex w-full bg-blue-200 text-blue-800 px-4 py-4 md:rounded-l-md text-sm"}>
                            Prezado usuário, a nova versão do launcher (v{process.env.REACT_APP_VERSION}) já está
                            disponível. Atualize para garantir a melhor experiência.
                        </div>
                    </div>

                    <div onClick={handleUpdateClickBtn}
                         className={"flex md:w-1/5 bg-blue-500 md:rounded-r-[30px] items-center justify-center text-white cursor-pointer select-none"}>
                        Atualizar
                    </div>
                </div>
            </div>
        </div>

        <div className={"w-full p-8"}>
            <div className="mb-8">
                <div className="flex items-center mb-4">
                    <i className="fas fa-newspaper text-blue-500 mr-2"></i>
                    <h3 className="text-xl font-semibold text-gray-800">Últimas nóticias</h3>
                </div>

                <div className="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 space-y-4">
                    {!noticesLoading ? (notices.map((item) => (
                        <div className="news-item bg-white p-4 rounded-lg shadow-sm cursor-pointer"
                             onClick={() => navigate(`/showNotice/${item.id}`)}>
                            <div className="flex items-start">
                                <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3">
                                    <i className="fa-solid fa-bullhorn"></i>
                                </div>
                                <div>
                                    <h4 className="font-medium text-gray-800">{item.title}</h4>
                                    <p
                                        className="text-sm text-gray-600 mt-1"
                                        dangerouslySetInnerHTML={{__html: truncate(item.content, 140)}}
                                    />

                                    <span
                                        className="text-xs text-gray-400 mt-1 block">{FormatDateTime(item.created_at)}</span>
                                </div>
                            </div>
                        </div>))) : (<NewLoading></NewLoading>)}
                </div>
            </div>
        </div>

        <SimpleModal title={"Baixando atualizações..."} content={<UpdateLauncherModal downloadedBytes={downloadBytes} progress={downloadProgress} totalBytes={downloadTotalBytes}></UpdateLauncherModal>} isModalOpen={isUpdateModalOpened} canClose={false}></SimpleModal>
    </div>);
};